import { IconProps } from './index';

const Bubble: React.VFC<IconProps> = ({ title, titleId, ...props }) => {
    return (
        <svg
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M5.62581 19.5506L0.33485 20.7266L1.51084 15.4356C0.736379 13.9869 0.332377 12.3692 0.33485 10.7266C0.33485 5.20356 4.81182 0.726562 10.3348 0.726562C15.8577 0.726562 20.3347 5.20356 20.3347 10.7266C20.3347 16.2496 15.8577 20.7266 10.3348 20.7266C8.69214 20.729 7.07441 20.325 5.62581 19.5506ZM5.91581 17.4376L6.5688 17.7876C7.72734 18.4067 9.02118 18.7293 10.3348 18.7266C11.917 18.7266 13.4637 18.2574 14.7793 17.3783C16.0949 16.4993 17.1203 15.2498 17.7258 13.788C18.3312 12.3262 18.4897 10.7177 18.181 9.16584C17.8723 7.61399 17.1104 6.18853 15.9916 5.06971C14.8728 3.95089 13.4473 3.18896 11.8955 2.88028C10.3436 2.5716 8.73513 2.73003 7.27333 3.33553C5.81153 3.94103 4.56211 4.96641 3.68307 6.282C2.80402 7.59759 2.33483 9.14431 2.33483 10.7266C2.33483 12.0606 2.65983 13.3446 3.27483 14.4926L3.62382 15.1456L2.96883 18.0926L5.91581 17.4376Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Bubble;
